import { render, staticRenderFns } from "./GroupMembers.vue?vue&type=template&id=761077e4&scoped=true"
import script from "./GroupMembers.vue?vue&type=script&lang=ts"
export * from "./GroupMembers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761077e4",
  null
  
)

export default component.exports